import { useVersion } from '@/hooks/use-version';
import { FRANJA_PILOTO_TEXTO, FRANJA_PILOTO_TITULO, esModoPiloto } from '@/lib/piloto';

// Franja del piloto de producción 4.0.0 (context/runbook_produccion_piloto.md
// §2.3): con MODO_PILOTO=1 en el backend, GET /api/health trae `piloto: true`
// y esta franja aparece arriba del contenido en toda la app (Layout y Login).
// Sin la variable no se renderiza nada (tampoco mientras /api/health no
// respondió); en el corte real se borra la variable y desaparece sin release.
//
// Fija: vive FUERA del <main> que scrollea (Layout) o arriba de la card
// (Login), así que no se va con el scroll. SUTIL (Juan, 25/9: «dale, pero
// sutil»): una línea de 12 px en gris sobre surface-2, con un punto ámbar como
// única nota de color; sin cerrar ni animar. muted-foreground sobre surface-2
// pasa AA en los dos temas. `role="region"` + nombre: los lectores de pantalla
// la encuentran como landmark y la leen antes del contenido.
export function FranjaPiloto() {
  const { data } = useVersion();
  if (!esModoPiloto(data)) return null;

  return (
    <div
      role="region"
      aria-label="Aviso del piloto"
      className="flex flex-none items-center justify-center gap-2 border-b border-border-subtle bg-surface-2 px-4 py-1 text-center text-[12px] leading-[1.35] text-muted-foreground"
    >
      <span className="size-1.5 flex-none rounded-full bg-ilu-amber" aria-hidden="true" />
      <p className="m-0 text-balance">
        <span className="font-semibold text-foreground">{FRANJA_PILOTO_TITULO}</span> — {FRANJA_PILOTO_TEXTO}
      </p>
    </div>
  );
}
